export default "skymp5-front/65e62b5eaf933b79e033a291becd058d.png";